import { Box, Typography } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

/**
 * TBM 단계 이동 중 전환 오버레이
 * - 최소 1초 / 최대 3초 표시 (usePdfStepTransition 훅과 연동)
 * - isTransitioning === true 일 때만 렌더
 * - direction: 'next'(기본) | 'prev'
 */
export default function TbmStepTransitionOverlay({ open, direction = 'next' }) {
  if (!open) return null;

  const isPrev = direction === 'prev';

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        // 배경 블러
        bgcolor: 'rgba(248, 249, 255, 0.85)',
        backdropFilter: 'blur(6px)',
      }}
    >
      {/* 앰비언트 블롭 - 상단 좌측 */}
      <Box
        sx={{
          position: 'absolute',
          top: '-10%',
          left: '-10%',
          width: '60%',
          height: '60%',
          borderRadius: '50%',
          background: 'rgba(211, 228, 255, 0.6)',
          filter: 'blur(80px)',
          pointerEvents: 'none',
        }}
      />
      {/* 앰비언트 블롭 - 하단 우측 */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '-10%',
          right: '-10%',
          width: '50%',
          height: '50%',
          borderRadius: '50%',
          background: 'rgba(67, 136, 253, 0.08)',
          filter: 'blur(80px)',
          pointerEvents: 'none',
        }}
      />

      {/* 카드 */}
      <Box
        sx={{
          position: 'relative',
          width: '85%',
          maxWidth: 340,
          background: 'rgba(248, 249, 255, 0.80)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          borderRadius: '1.5rem',
          boxShadow: '0 8px 32px rgba(15, 52, 88, 0.08)',
          border: '1px solid rgba(149, 180, 224, 0.18)',
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        {/* 아이콘 */}
        <Box sx={{ position: 'relative', mb: 4 }}>
          {/* 글로우 */}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #005bc4, #4388fd)',
              filter: 'blur(10px)',
              opacity: 0.4,
              '@keyframes tbmPulse': {
                '0%, 100%': { opacity: 0.4 },
                '50%': { opacity: 0.65 },
              },
              animation: 'tbmPulse 2s ease-in-out infinite',
            }}
          />
          <Box
            sx={{
              position: 'relative',
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #005bc4, #4388fd)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 'inset 0 2px 8px rgba(255,255,255,0.3)',
            }}
          >
            <ConstructionIcon sx={{ color: '#fff', fontSize: 30 }} />
          </Box>
        </Box>

        {/* 제목 */}
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontSize: '1.2rem',
            fontWeight: 800,
            color: '#0f3458',
            letterSpacing: '-0.02em',
            mb: 1.5,
            lineHeight: 1.3,
          }}
        >
          {isPrev ? '이전 단계로 이동 중...' : '다음 단계로 이동 중...'}
        </Typography>

        {/* 부제목 */}
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontSize: '0.85rem',
            color: '#426188',
            lineHeight: 1.65,
            mb: 4,
          }}
        >
          {isPrev
            ? <>이전 단계로 돌아가고 있습니다.<br />잠시만 기다려주세요.</>
            : <>현장의 안전을 위해 다음 단계를<br />구성하고 있습니다.<br />잠시만 기다려주세요.</>}
        </Typography>

        {/* 프로그레스 바 */}
        <Box
          sx={{
            width: '100%',
            height: 6,
            bgcolor: '#dce9ff',
            borderRadius: 999,
            overflow: 'hidden',
            mb: 4,
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <Box
            sx={{
              height: '100%',
              width: '50%',
              background: 'linear-gradient(90deg, #005bc4, #4388fd)',
              borderRadius: 999,
              '@keyframes tbmBarPulse': {
                '0%': { transform: 'translateX(-100%)' },
                '100%': { transform: 'translateX(300%)' },
              },
              animation: 'tbmBarPulse 1.8s ease-in-out infinite',
            }}
          />
        </Box>

        {/* 하단 레이블 */}
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontSize: '0.68rem',
            fontWeight: 700,
            letterSpacing: '0.15em',
            color: 'rgba(66, 97, 136, 0.55)',
            textTransform: 'uppercase',
          }}
        >
          SETTING UP TBM ENVIRONMENT
        </Typography>
      </Box>
    </Box>
  );
}
